// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreFulfillmentDocuments = (client) => ({
    /**
     * `GET /store/fulfillment-documents/:id/signed-url`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetFulfillmentDocumentSignedUrl
     * @source packages/medusa-plugin-fulfillment-documents/src/api/store/fulfillment-documents/[id]/signed-url/route.ts
     */
    retrieveSignedUrl: (id, query, headers) => client.fetch(buildPath("/store/fulfillment-documents/:id/signed-url", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=fulfillment-documents.js.map